import enPdf from "@/assets/file/constitution-en.pdf";
import zhPdf from "@/assets/file/constitution-zh.pdf";

const File = () => {
	const lang = localStorage.getItem("lang") || "en-US";
	return <div className="container" style={{ marginTop: "-80px" }}>
		<iframe title="fileUrl" src={lang === "en-US" ? enPdf : zhPdf} width="100%" height="100%" style={{ height: "calc(100vh - 8px)" }} />
	</div>
}
export default File;